import React, { useState } from 'react';
import { Card } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { Session } from '@juno/client-api/model';
import { Container } from '@juno/ui';
import { useSettings } from '@juno/utils';
import { ProductStatus } from '../';
import App from '../components/App';
import { CHAT_ASIDE, PEOPLE_ASIDE, QA_ASIDE } from '../constants';
import { CallProvider } from '../contexts/CallProvider';
import { ChatProvider } from '../contexts/ChatProvider';
import { MediaDeviceProvider } from '../contexts/MediaDeviceProvider';
import { ParticipantsProvider } from '../contexts/ParticipantsProvider';
import { ScreenShareProvider } from '../contexts/ScreenShareProvider';
import { TracksProvider } from '../contexts/TracksProvider';
import { UIStateProvider } from '../contexts/UIStateProvider';
import PrejoinPage from './PrejoinPage';

interface MainPageProps {
  sessionData: Session;
  cancelPrejoin: () => void;
  isPaywalled: boolean;
  productStatus: ProductStatus;
}
const MainPage: React.FC<MainPageProps> = ({ sessionData, cancelPrejoin }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { room_url } = sessionData;
  const { showSideMenu, showMessenger } = useSettings();
  // Add asides and modals here
  const asides: any[] = [CHAT_ASIDE, PEOPLE_ASIDE, QA_ASIDE];
  const modals: any[] = [];
  const customTrayComponent = null;
  const withAudio = searchParams.get('withAudio') === 'true';
  const withVideo = searchParams.get('withVideo') === 'true';
  const [hasJoined, setHasJoined] = useState(withAudio || withVideo);

  return (
    <UIStateProvider asides={asides} modals={modals} customTrayComponent={customTrayComponent}>
      {/* @ts-expect-error: Dom said so */}
      <CallProvider roomUrl={room_url}>
        {/* @ts-expect-error: Dom said so */}
        <ParticipantsProvider>
          <TracksProvider>
            <MediaDeviceProvider>
              {/* @ts-expect-error: Dom said so */}
              <ScreenShareProvider>
                {/* @ts-expect-error: Dom said so */}
                <ChatProvider>
                  {/* @ts-expect-error: Dom said so */}
                  {hasJoined ? (
                    <App
                      withAudio={withAudio}
                      withVideo={withVideo}
                      leaveCall={() => {
                        // TODO this throws an error in the console about trying to render main and app at the same time
                        setHasJoined(false);
                        cancelPrejoin();
                      }}
                      sessionData={sessionData}
                    />
                  ) : (
                    <Container sx={{ width: 800, pb: 6 }}>
                      <Card
                        sx={{
                          p: 2,
                          mt: showMessenger || showSideMenu ? 0 : 2,
                          transition: '200ms',
                        }}
                      >
                        <PrejoinPage
                          sessionData={sessionData}
                          joinCall={() => setHasJoined(true)}
                          cancelCall={cancelPrejoin}
                        />
                      </Card>
                    </Container>
                  )}
                </ChatProvider>
              </ScreenShareProvider>
            </MediaDeviceProvider>
          </TracksProvider>
        </ParticipantsProvider>
      </CallProvider>
    </UIStateProvider>
  );
};
export default MainPage;
